function RoadmapActivity({ name, description, progress, release_date, stage }) {
    return (
        <div className="row mt-5">
            <div className="col-4">
                <b>{name}</b><br />
                {description}
            </div>
            <div className="col-2">{stage.name}</div>
            <div className="col-4">
                <div style={{ width: '100%', height: '50px', border: '5px solid ' + stage.color }}>
                    <div style={{ width: progress + '%', height: '45px', backgroundColor: stage.color }}></div>
                </div>
            </div>
            <div className="col-2">{release_date}</div>
        </div>
    );
}


export default RoadmapActivity;